import React from 'react'
import JoseAldoComp from '../../components/sponsorships/JoseAldo'

const JoseAldo = () => {
  return (
    <JoseAldoComp/>
  )
}

export default JoseAldo